export const environment = {
    production: true,
    domain: '.lecedre.fr',
    urls: {
        loginRadius: 'https://api.loginradius.com/',
        api: 'http://localhost:8080/',
        digicedra: 'https://adherents.lecedre.fr/',
        digierp: 'https://collaborateurs.lecedre.fr/',
        portal: 'https://connexion.lecedre.fr/',
        commonStatic: 'https://static-common.lecedre.fr/',
        datahub: 'https://hub.lecedre.fr/',
        dcm: 'https://dcm.app.lecedre.fr/wp-json/',
        financial: 'https://financial.lecedre.fr/',
        v2: 'https://v2.api.lecedre.fr/',
        salesforce: 'https://lecedre.lightning.force.com/',
        s3: 'https://dcm.datas.lecedre.fr/common/collab/',
        bucketName: 'datas.lecedre.fr',
    },
    commonOptions: {
        sott: 'f+Qgx5M+Bg18Euol6K8a6jOEDTse6w4H/Nv7gydvC5J430ti7MzyoBJBiZBzfCIa56GIWtiBzvNOY1biKpKujVYxDbZ+WljeThuafQCZnOo=*2dbcb1369dede0991c28c34cfe26918e',
        appName: 'lecedre',
        hashTemplate: true,
        verificationUrl: 'https://connexion.lecedre.fr/',
        resetPasswordUrl: 'https://connexion.lecedre.fr/',
        recaptchaPublicKey: '6LfZUbkqAAAAABrrlUBG-goaEK-1yStPJeUIuYSm',
        recaptchaPrivateKey: '6LfZUbkqAAAAAED04xA40XlOuzzRij8NLqdtOFtd',
        loginRadiusClientId: 'a93bd75d-d059-420f-9782-b9e99b3a5ff3',
        googleClientId: '973909085044-rbgu6lleu4oijrjv04dj18rnemu824kq.apps.googleusercontent.com',
        availableFeatures: [],
        activatedFeatures: [],
    },
    apps: {
        EA: 'https://adherents.lecedre.fr',
        DE: 'https://collaborateurs.lecedre.fr',
        EF: 'https://fournisseurs.lecedre.fr',
    },
    universalGtag: {
        EA: 'UA-137385956-1',
        DE: 'UA-137385956-1',
    },
    trads: {
        tradApp: 'portal',
        tradEnv: 'PROD', // 'RC' or 'PROD'
        tradUrl: 'https://translate-cedre.s3.eu-west-1.amazonaws.com/',
    },
};
